import axios from 'axios';
// import store from '@/store';

export const CLEAR_ITEMS = ({ commit }) => {
  commit('CLEAR_ITEMS');
}

export const SET_ERROR = ({ commit }, payload) => {
  commit('SET_ERROR', payload.errors);
}

export const CHANGE_DISPLAY_STYLE = ({ commit }, { display }) => {
  commit('UPDATE_DISPLAY_STYLE', { display });
}

export const SORT = ({ commit }, { direction, field }) => {
  commit('SORT', { direction, field });
}

export const RESET_ERRORS = ({ commit }) => commit('RESET_ERRORS')
export const RESET_STATUS = ({ commit }) => commit('UPDATE_STATUS', null)

export const FETCH_ALL = (url, cb = null) => {
  return async ({ commit, dispatch }) => {
    commit('UPDATE_STATUS', 'loading');

    try {
      const { data } = await axios.get(url);

      commit('UPDATE_STATUS', 'success');
      commit('SET_ITEMS', data);

      if (cb) {
        cb();
      }
    } catch (error) {
      console.error('error', error);
      commit('UPDATE_STATUS', 'error');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch items. try again later.',
        { root: true }
      );
    }
  };
}
export const FETCH_MORE = (url = null, cb = null) => {
  return async ({ commit, dispatch }) => {
    // fetch the next page of items if there is a next page
    if (url) {
      commit('UPDATE_STATUS', 'loading');

      try {
        const { data } = await axios.get(url);
        commit('UPDATE_STATUS', 'success');
        commit('ADD_ITEMS', data);

        if (cb) {
          cb();
        }
      } catch (error) {
        console.error(error);
        commit('UPDATE_STATUS', 'error');
        dispatch(
          'notification/ERROR_NOTIFICATION',
          'could not fetch items. try again later.',
          { root: true }
        );
      }
    }
  };
}
export const FETCH = (url, cb = null) => {
  return async ({ commit, dispatch }, slug, state) => {
    // check to see if item is already in list
    const inList = state.items.find((o => o.slug === slug));

    if (!inList || (!inList.prev && !inList.next)) {
      commit('UPDATE_STATUS', 'loading');

      try {
        const { data } = await axios.get(url);
        commit('UPDATE_STATUS', 'success');
        commit('ADD_ITEM', data);

        if (cb) {
          await cb();
        }
      } catch (error) {
        console.error(error);
        commit('UPDATE_STATUS', 'error');
        dispatch(
          'notification/ERROR_NOTIFICATION',
          'could not fetch item. try again later.',
          { root: true }
        );
      }
    } else {
      if (cb) {
        cb();
      }
    }
  };
}
export const FETCH_GROUPINGS = url => {
  return async ({ commit, dispatch }, { slug, num }) => {
    console.log('FETCH_GROUPINGS', { slug, num });
    commit('UPDATE_STATUS', 'loading');
    try {
      const { data } = await axios.get(url);

      commit('UPDATE_STATUS', 'success');
      commit('grouping/SET_ITEMS', data, { root: true });
      commit('SET_NEXT_URL', {
        slug: slug,
        url: data.links.next
      });
    } catch (error) {
      console.error(error);
      commit('UPDATE_STATUS', 'error');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch groupings. try again later.',
        { root: true }
      );
    }
  };
  // };
}
export const FETCH_MORE_GROUPINGS = url => {
  console.log('FETCH_MORE_GROUPINGS', url);
  return async ({ commit, dispatch }, { slug }) => {
    // fetch next "page" of groups that belong to the item
    if (url) {
      commit('UPDATE_STATUS', 'loading');

      try {
        const { data } = await axios.get(url);

        commit('SET_NEXT_URL', {
          slug: slug,
          url: data.links.next
        });
        commit('UPDATE_STATUS', 'success');
        commit('grouping/ADD_ITEMS', data, { root: true });
      } catch (error) {
        console.error(error);
        commit('UPDATE_STATUS', 'error');
        dispatch(
          'notification/ERROR_NOTIFICATION',
          'could not fetch groupings. try again later.',
          { root: true }
        );
      }
    }
  };
}
export const ADD = url => {
  return async ({ commit, dispatch }, payload) => {
    commit('UPDATE_STATUS', 'loading');
    try {
      const { data } = await axios.post(url, payload);
      commit('ADD_ITEM', data);
      dispatch(
        'notification/SUCCESS_NOTIFICATION',
        'the new item was added successfully',
        { root: true }
      );
      commit('UPDATE_STATUS', 'success');

      return data;
    } catch (error) {
      console.error(error);
      commit('UPDATE_STATUS', 'error');

      if (error && error.response) {
        commit('SET_ERROR', error.response.data.errors);
      }

      dispatch(
        'notification/ERROR_NOTIFICATION',
        'item could not be added. try again later.',
        { root: true }
      );
    }
  };
}
export const UPDATE = url => {
  return async ({ commit, dispatch }, payload) => {
    commit('UPDATE_STATUS', 'loading');
    try {
      const { data } = await axios.put(url, payload);
      // console.log(data);
      commit('UPDATE_ITEM', data);
      dispatch(
        'notification/SUCCESS_NOTIFICATION',
        'the item was updated successfully',
        { root: true }
      );
      commit('UPDATE_STATUS', 'success');
    } catch (error) {
      console.error(error);
      commit('UPDATE_STATUS', 'error');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'item could not be updated. try again later.',
        { root: true }
      );
    }
  };
}
export const REMOVE = url => {
  return async ({ commit, dispatch }, { slug }) => {
    commit('UPDATE_STATUS', 'loading');
    // console.log(payload);
    try {
      await axios.delete(url);
      commit('REMOVE_ITEM', slug);
      dispatch(
        'notification/SUCCESS_NOTIFICATION',
        'the item was removed successfully',
        { root: true }
      );
      commit('UPDATE_STATUS', 'success');
    } catch (error) {
      console.error(error);
      // remove item from database
      commit('UPDATE_STATUS', 'error');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'item could not be removed. try again later.',
        { root: true }
      );
    }
  };
}
export const FETCH_PONIES = url => {
  return async ({ commit, dispatch }, payload) => {
    console.log('FETCH_PONIES', payload);

    commit('UPDATE_STATUS', 'loading');
    try {
      const { data } = await axios.get(url);

      commit('UPDATE_STATUS', 'success');
      commit('pony/SET_ITEMS', data, { root: true });
      commit('SET_NEXT_URL', {
        slug: payload.slug,
        url: data.links.next
      });
    } catch (error) {
      console.error(error);
      commit('UPDATE_STATUS', 'error');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch ponies. try again later.',
        { root: true }
      );
    }
  };
}

export const FETCH_MORE_PONIES = url => {
  return async ({ commit, dispatch }, payload) => {
    // fetch next "page" of groups that belong to the item
    if (url) {
      commit('UPDATE_STATUS', 'loading');

      try {
        const { data } = await axios.get(url);
        console.log('next link', data.links?.next);
  
        if (url === data.links?.next) {
          console.error('url not updated');
          return;
        }

        commit('SET_NEXT_URL', {
          slug: payload.slug,
          url: data.links?.next
        });
        commit('UPDATE_STATUS', 'success');
        commit('pony/ADD_ITEMS', data, { root: true });
      } catch (error) {
        console.error(error);
        commit('UPDATE_STATUS', 'error');
        dispatch(
          'notification/ERROR_NOTIFICATION',
          'could not fetch ponies. try again later.',
          { root: true }
        );
      }
    }
  };
}

export default {
  CLEAR_ITEMS,
  FETCH,
  FETCH_ALL,
  FETCH_GROUPINGS,
  FETCH_MORE,
  FETCH_MORE_GROUPINGS,
  ADD,
  FETCH_PONIES,
  FETCH_MORE_PONIES,
  UPDATE,
  REMOVE,
  SORT,
  SET_ERROR,
  CHANGE_DISPLAY_STYLE,
  RESET_ERRORS,
  RESET_STATUS,
};
